<div class="absolute top-[48px] z-[1] left-0 w-full lg:left-[260px] lg:w-[calc(100%-260px)]">
	@for (alert of alerts; track alert) {
		<p-message
			size="large"
			class="border-b"
			styleClass="rounded-none outline-0 border-b"
			[closable]="true"
			[severity]="alert.severity"
			(onClose)="onAlertRemove(alert)"
		>
			{{ alert.message }}
		</p-message>
	}
</div>
